/**
 * Runtime configuration injected via window.__RUNTIME_CONFIG__ (populated by
 * envsubst at container startup). Falls back to Vite build-time env vars for
 * local development.
 */
const rc = (window as unknown as Record<string, unknown>).__RUNTIME_CONFIG__ as Record<string, string> | undefined;

function env(runtimeKey: string, viteKey: string, fallback: string = ''): string {
  const runtimeVal = rc?.[runtimeKey];
  if (runtimeVal && !runtimeVal.startsWith('${')) return runtimeVal;
  return import.meta.env[viteKey] || fallback;
}

export const config = {
  firebase: {
    apiKey: env('FIREBASE_API_KEY', 'VITE_FIREBASE_API_KEY'),
    authDomain: env('FIREBASE_AUTH_DOMAIN', 'VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: env('PROJECT_ID', 'VITE_FIREBASE_PROJECT_ID', 'bombora-dev'),
  },

  auth0: {
    oidcProviderId: env('AUTH0_OIDC_PROVIDER_ID', 'VITE_AUTH0_OIDC_PROVIDER_ID', 'oidc.auth0'),
  },

  urls: {
    noAccessUrl: env('NO_ACCESS_URL', 'VITE_NO_ACCESS_URL', 'https://static.gcp.bommdev.in/errors/403.html'),
    errorUrl: env('ERROR_URL', 'VITE_ERROR_URL', 'https://static.gcp.bommdev.in/errors/500.html'),
  },

  tenantId: env('TENANT_ID', 'VITE_TENANT_ID') || null,
};

/**
 * Validate that required configuration is present.
 */
export function validateConfig(): void {
  const required = [
    ['VITE_FIREBASE_API_KEY', config.firebase.apiKey],
    ['VITE_FIREBASE_AUTH_DOMAIN', config.firebase.authDomain],
    ['VITE_TENANT_ID', config.tenantId],
  ];

  const missing = required.filter(([, value]) => !value);

  if (missing.length > 0) {
    const names = missing.map(([name]) => name).join(', ');
    throw new Error(
      `Missing required configuration: ${names}. ` +
      'TENANT_ID is required to isolate this identity broker from other environments.'
    );
  }
}
